// Auto-generated by splitter.py — do not regenerate; edit directly.

import { MOCK } from './mock';

export const MOCK_TOURNAMENTS_RICH = [
  {
    id: 'TRN-2026-001', code: 'UPL2526', name: 'Uganda Premier League 2025/26', logo: 'UPL',
    organizer: 'FUFA Commercial', season: '2025/26', status: 'Active',
    description: 'Top-flight Ugandan football league · 16 teams · home-and-away · September to May.',
    ticketDesign: 'TPL-TKT-001 · Akibua Match-Day Ticket v4',
    venues: ['VEN-001','VEN-006'],
    teams: ['TM-001','TM-002','TM-003','TM-004','TM-005','TM-006'],
    seatPlans: ['SP-001','SP-501'],
    eventsCount: 240, fixturesPlayed: 218, fixturesUpcoming: 22,
    onboarded: '08 Aug 2025', operator: 'Brian O.',
    grossSales: 2_840_000_000, ordersTotal: 64_200, payoutsTotal: 2_410_000_000,
  },
  {
    id: 'TRN-2026-002', code: 'AFCONQ26', name: 'AFCON Qualifiers — Uganda', logo: 'AQ',
    organizer: 'FUFA Commercial', season: '2026', status: 'Active',
    description: 'Africa Cup of Nations qualifying matches hosted by Uganda. International fixtures · televised · high-demand.',
    ticketDesign: 'TPL-TKT-002 · FUFA Qualifier Ticket v2',
    venues: ['VEN-001'],
    teams: ['TM-007'],
    seatPlans: ['SP-001'],
    eventsCount: 6, fixturesPlayed: 3, fixturesUpcoming: 3,
    onboarded: '14 Jan 2026', operator: 'Victor S.',
    grossSales: 1_640_000_000, ordersTotal: 28_400, payoutsTotal: 1_390_000_000,
  },
  {
    id: 'TRN-2026-003', code: 'URS26', name: 'URA Rugby Sevens Circuit', logo: 'UR',
    organizer: 'URA Sports Club', season: '2026', status: 'Active',
    description: 'National rugby sevens circuit · 6-leg series · Kampala / Jinja / Mbarara venues. Single-day tournaments.',
    ticketDesign: 'TPL-TKT-009 · Rugby Sevens Ticket v1',
    venues: ['VEN-002','VEN-005'],
    teams: ['TM-008','TM-009'],
    seatPlans: ['SP-101','SP-401'],
    eventsCount: 18, fixturesPlayed: 4, fixturesUpcoming: 14,
    onboarded: '02 Mar 2026', operator: 'Lillian K.',
    grossSales: 184_000_000, ordersTotal: 8_400, payoutsTotal: 162_000_000,
  },
  {
    id: 'TRN-2026-004', code: 'NBL26', name: 'National Basketball League 2025/26', logo: 'NBL',
    organizer: 'FUBA Commercial', season: '2025/26', status: 'Active',
    description: 'National basketball league · 10 teams · indoor venue rotation. Lugogo Indoor Stadium hosts marquee fixtures.',
    ticketDesign: 'TPL-TKT-011 · Basketball Ticket v3',
    venues: ['VEN-002','VEN-003'],
    teams: ['TM-010','TM-011'],
    seatPlans: ['SP-102','SP-201'],
    eventsCount: 84, fixturesPlayed: 62, fixturesUpcoming: 22,
    onboarded: '14 Nov 2025', operator: 'Esther N.',
    grossSales: 412_000_000, ordersTotal: 18_400, payoutsTotal: 348_000_000,
  },
  {
    id: 'TRN-2025-099', code: 'UPL2425', name: 'Uganda Premier League 2024/25', logo: 'UPL',
    organizer: 'FUFA Commercial', season: '2024/25', status: 'Completed',
    description: 'Previous UPL season · concluded May 2025.',
    ticketDesign: 'TPL-TKT-001 · Akibua Match-Day Ticket v4',
    venues: ['VEN-001','VEN-006'],
    teams: ['TM-001','TM-002','TM-003','TM-004'],
    seatPlans: ['SP-001','SP-501'],
    eventsCount: 240, fixturesPlayed: 240, fixturesUpcoming: 0,
    onboarded: '04 Aug 2024', operator: 'Brian O.',
    grossSales: 2_620_000_000, ordersTotal: 58_400, payoutsTotal: 2_480_000_000,
  },
];


export const MOCK_TEAMS_RICH = [
  { id: 'TM-001', name: 'KCCA FC',        shortName: 'KCCA', logo: 'KC', country: 'Uganda',  city: 'Kampala',  tournaments: ['TRN-2026-001','TRN-2025-099'], events: 28, status: 'Active' },
  { id: 'TM-002', name: 'Vipers SC',      shortName: 'VIP',  logo: 'VS', country: 'Uganda',  city: 'Kitende',  tournaments: ['TRN-2026-001','TRN-2025-099'], events: 30, status: 'Active' },
  { id: 'TM-003', name: 'Express FC',     shortName: 'EXP',  logo: 'EX', country: 'Uganda',  city: 'Kampala',  tournaments: ['TRN-2026-001','TRN-2025-099'], events: 24, status: 'Active' },
  { id: 'TM-004', name: 'SC Villa',       shortName: 'VIL',  logo: 'SV', country: 'Uganda',  city: 'Kampala',  tournaments: ['TRN-2026-001','TRN-2025-099'], events: 26, status: 'Active' },
  { id: 'TM-005', name: 'BUL FC',         shortName: 'BUL',  logo: 'BU', country: 'Uganda',  city: 'Jinja',    tournaments: ['TRN-2026-001'],                events: 18, status: 'Active' },
  { id: 'TM-006', name: 'URA FC',         shortName: 'URA',  logo: 'UR', country: 'Uganda',  city: 'Kampala',  tournaments: ['TRN-2026-001'],                events: 16, status: 'Active' },
  { id: 'TM-007', name: 'Uganda Cranes',  shortName: 'UGA',  logo: 'UC', country: 'Uganda',  city: 'Kampala',  tournaments: ['TRN-2026-002'],                events: 6,  status: 'Active' },
  { id: 'TM-008', name: 'Heathens Rugby', shortName: 'HTH',  logo: 'HR', country: 'Uganda',  city: 'Kampala',  tournaments: ['TRN-2026-003'],                events: 6,  status: 'Active' },
  { id: 'TM-009', name: 'Pirates Rugby',  shortName: 'PIR',  logo: 'PR', country: 'Uganda',  city: 'Kampala',  tournaments: ['TRN-2026-003'],                events: 6,  status: 'Active' },
  { id: 'TM-010', name: 'City Oilers',    shortName: 'CO',   logo: 'CO', country: 'Uganda',  city: 'Kampala',  tournaments: ['TRN-2026-004'],                events: 14, status: 'Active' },
  { id: 'TM-011', name: 'KCCA Leopards',  shortName: 'KCL',  logo: 'KL', country: 'Uganda',  city: 'Kampala',  tournaments: ['TRN-2026-004'],                events: 12, status: 'Active' },
];

/* ============================================================================
   END VENUES/TOURNAMENTS MOCK
   ============================================================================ */

